<script>
import Nav from '@/components/comm/Nav.vue';

export default {
  name: 'MainLayout',
  components: { Nav },
  data() {
    return {
      loadingPayment: true,
      bills: [],
    };
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <div class="page bar-content">
      <Nav :calculate="false" />
      <div class="page-container">
        <router-view :key="key" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
@import '~@/assets/css/main.less';
@import '~@/assets/fonts/font.less';
.page {
  background-color: @app-bg-color;
  padding-bottom: 56px;
  position: relative;
  min-height: 100%;
  .page-container {
    width: 1148px;
    background-color: #fff;
    margin: 27px auto 0;
    padding: 30px;
    height: 100%;
    &:after {
      content: ' ';
      display: block;
      clear: both;
    }
  }
}
</style>
